import { SET_URLAUB_DATA } from "../constants/actions";
import { privateApi as API } from "../utils/api";
import refreshToken from "./refreshToken";

export type UrlaublData = {
  title: string;
  text: string;
  unpaidVacationBox: {
    amount: number;
    subTitle: string;
    isVisible: boolean;
  };
  actionsBox: {
    title: string;
    text: string;
    isVisible: boolean;
    actionList: {
      title: string;
      text: string;
    }[];
  };
  optionsBox: {
    isVisible: boolean
    title: string;
    text: string;
  };
  contactBox: {
    title: string;
    text: string;
    link: string;
    linkText: string;
    isVisible: boolean;
  };
  unpaidVacationPageContentBox: {
    content: string;
  };
};

export const getUrlaubData = (payload) => {
  const token = localStorage.getItem("ip_access_token");
  return async function (dispatch) {
    try {
      const response: { data: { data: UrlaublData } } = await API.get(
        "pages/unpaidvacation"
      );
      dispatch({
        type: SET_URLAUB_DATA,
        payload: response.data.data,
      });
      await refreshToken(null);
      return response;
    } catch (err) {
      return err;
    }
  };
};
